import { render, staticRenderFns } from "./collect_pdffz.vue?vue&type=template&id=0d66d228&"
import script from "./collect_pdffz.vue?vue&type=script&lang=js&"
export * from "./collect_pdffz.vue?vue&type=script&lang=js&"
import style0 from "./collect_pdffz.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports